import configureAxios from 'configure/axios';

const axios = configureAxios();

export const fetchAll = (subId) => axios.get('att/plans/',  { params: { subscription_id: subId } });
export const find = (id) => axios.get(`att/plans/${id}/`);
export const upcomingCycles = (subscription) => axios.get('att/cycles/upcoming/', { params: { subscription } });
